<div class="industry-delete-dialog">
  <button class="close-btn" type="button" (click)="cancel()" [attr.aria-label]="'common.close_dialog' | translate">&times;</button>

  <h2 class="title">{{ 'fee.industry_delete.title' | translate }}</h2>

  <p class="description">
    {{ 'fee.industry_delete.contains_data_title' | translate }}
    {{ 'fee.industry_delete.contains_data_description' | translate }}
  </p>

  <div class="actions">
    <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn-delete" [disabled]="deleting" (click)="confirmDelete()">
      {{ (deleting ? 'fee.industry_delete.deleting' : 'fee.industry_delete.confirm') | translate }}
    </button>
  </div>
</div>
